import setPeopleCardRoute from '../actions/setPeopleCardRoute';
import { getPeopleCardRouteStore } from '../store/Store';
import { mutator } from 'satcheljs';

export default mutator(setPeopleCardRoute, actionMessage => {
    const store = getPeopleCardRouteStore();
    store.currentRoute = actionMessage.route;
    store.peopleCardMountProps = actionMessage.peopleCardMountProps;
});
